import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TreePine, ArrowRight, Phone, Mail, Home, Search, Truck, Compass } from 'lucide-react';
import { COMPANY_INFO } from '../data';

export default function NotFoundPage() {
  useEffect(() => {
    document.title = `404 - Siden blev ikke fundet | ${COMPANY_INFO.name}`;
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', "Den ønskede side blev desværre ikke fundet. Find vej til skovservice, vognmandskørsel eller kontakt Vesthimmerlands Maskinskovning ApS.");
    }
  }, []);

  return (
    <div className="bg-stone-950 min-h-[75vh] flex flex-col justify-center py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center space-y-8">
        {/* Status code badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-stone-900 border border-stone-800 text-swamp-300 text-sm font-bold tracking-widest uppercase">
          <Compass className="w-4 h-4 text-emerald-500" />
          <span>Fejlkode 404 &bull; Side ikke fundet</span>
        </div>

        <div className="space-y-4">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white uppercase tracking-tight">
            Siden du leder efter findes ikke
          </h1>
          <p className="text-stone-400 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
            Vi beklager, men den adresse du forsøgte at tilgå er flyttet, slettet eller har ændret navn. Du kan bruge genvejene herunder til at finde det, du søger.
          </p>
        </div>

        {/* Quick Service Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-6 text-left max-w-3xl mx-auto">
          <Link 
            to="/vognmand" 
            className="p-5 rounded-xl bg-stone-900/60 border border-stone-800 hover:border-emerald-700/60 hover:bg-stone-900 transition-all group"
          >
            <div className="w-10 h-10 rounded-lg bg-swamp-900/90 border border-swamp-700 flex items-center justify-center mb-3">
              <Truck className="w-5 h-5 text-swamp-300" />
            </div>
            <h3 className="font-bold text-white text-base group-hover:text-emerald-400 transition-colors">Vognmand &amp; Transport</h3>
            <p className="text-xs text-stone-400 mt-1">Walking floor, blokvogn og bulkgods i hele Danmark.</p>
          </Link>

          <Link 
            to="/skovservice" 
            className="p-5 rounded-xl bg-stone-900/60 border border-stone-800 hover:border-emerald-700/60 hover:bg-stone-900 transition-all group"
          >
            <div className="w-10 h-10 rounded-lg bg-swamp-900/90 border border-swamp-700 flex items-center justify-center mb-3">
              <TreePine className="w-5 h-5 text-swamp-300" />
            </div>
            <h3 className="font-bold text-white text-base group-hover:text-emerald-400 transition-colors">Skovservice</h3>
            <p className="text-xs text-stone-400 mt-1">Maskinskovning, flishugning og udkørsel af træ.</p>
          </Link>

          <Link 
            to="/kontakt" 
            className="p-5 rounded-xl bg-stone-900/60 border border-stone-800 hover:border-emerald-700/60 hover:bg-stone-900 transition-all group"
          >
            <div className="w-10 h-10 rounded-lg bg-swamp-900/90 border border-swamp-700 flex items-center justify-center mb-3">
              <Phone className="w-5 h-5 text-swamp-300" />
            </div>
            <h3 className="font-bold text-white text-base group-hover:text-emerald-400 transition-colors">Kontakt os</h3>
            <p className="text-xs text-stone-400 mt-1">Ring på 96 98 20 00 eller få et uforpligtende tilbud.</p>
          </Link>
        </div>

        {/* Action Buttons */}
        <div className="pt-4 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-[#348F57] hover:bg-[#2a7346] text-white font-bold px-7 py-3.5 rounded-xl transition-all shadow-lg shadow-emerald-950/50 hover:shadow-emerald-900/40 uppercase text-sm tracking-wide"
          >
            <Home className="w-4 h-4" />
            <span>Gå til forsiden</span>
          </Link>
          <Link
            to="/kontakt"
            className="inline-flex items-center gap-2 bg-stone-900 hover:bg-stone-800 text-stone-200 hover:text-white font-bold px-7 py-3.5 rounded-xl transition-all border border-stone-800 uppercase text-sm tracking-wide"
          >
            <span>Få et tilbud</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
